export default __webpack_public_path__ + "static/media/Blob.1c138ea3.svg";